import React from 'react';
import OrderSettings from './OrderSettings';
import PurchaseSubHeader from './PurchaseSubHeader';

import { ApplicationState } from '../../../store';
import { useSelector } from 'react-redux';
import { GetFlag } from '../../../utils/featureFlag';
import { LongSteelMvp } from './LongSteelMvp';

const LongSteel: React.FC = () => {
  const JOURNEYVIEW_TYPE = 'commerce_magento';
  const journeyViews = useSelector(
    (appState: ApplicationState) => appState.user.journeyViews
  );

  const isMVPUser = journeyViews && journeyViews.includes(JOURNEYVIEW_TYPE);

  const flagNewPurchaseJourney = GetFlag('jornada_compras');

  if (isMVPUser && flagNewPurchaseJourney) {
    return <LongSteelMvp />;
  }

  return (
    <>
      <PurchaseSubHeader />
      <OrderSettings />
    </>
  );
};

export default LongSteel;
